import React, { Component } from "react";
import {
  Container,
  Grid,
  List,
  ListItem,
} from "@material-ui/core";
import { Card } from "react-bootstrap";
import RtiDescription from "./RtiDescription";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

const list = [
  {
    title: "RTI",
    link: "/rti/home",
    gr: 'home'
  },
  {
    title: "Members of the RTI Cell",
    link: "/rti/officers",
    gr: 'officers'
  },
  {
    title: "Self Declaration",
    link: "/rti/selfdec",
    gr: 'selfdec'
  },
  {
    title: "Code of Conduct",
    link: "/rti/code",
    gr: 'code'
  },
  {
    title: "RTI Act",
    link: "/rti/act",
    gr: 'act'
  },
  {
    title: "Infromation in Eletronic Form",
    link: "/rti/ief",
    gr: 'ief'
  },
  {
    title: "Particulars available to the Citizens",
    link: "/rti/pac",
    gr: 'pac'
  },
  // {
  //   title: "You can add more +",
  //   link: "/aboutus/about",
  // },
];

class RtiContainer extends Component {
  state = {
    link: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    return (
      <div>
        {/* <BreadCrumbOwn title="Home > RTI" />
        <Container className="mb-4">
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{ paddingTop: "5em" }}
            >
              <Card
                style={{
                  boxShadow: "none",
                  position: "stickey !important",
                  top: "0 !important",
                  // backgroundColor: '#EBDB86',
                  // border: `solid 2px #808080`
                }}
              >
                <div
                  style={{
                    boxShadow: "none",
                    position: "stickey",
                    top: "0",
                  }}
                >
                  <List component="nav">
                    {list.map((el, index) => (
                      <ListItem
                        button
                        style={{
                          border: "1px solid #0002",
                          marginBottom: "2px",
                          backgroundColor: el.link === `/rti/${this.state.link}` ? '#F5EB3D' :'#f9f9f9'
                        }}
                        key={index}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <div
                          style={{
                            fontSize: "1.2em",
                            fontWeight: "700",
                            padding: "0",
                          }}
                        >
                          {el.title}
                        </div>
                      </ListItem>
                    ))}
                  </List>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9} style={{minHeight: '800px'}}>
              <RtiDescription type={this.state.link} />
            </Grid>
          </Grid>
        </Container> */}

        <RtiDescription type={this.state.link} />
      </div>
    );
  }
}

export default RtiContainer;
